export default function Services({ className }) {
  const { services } = useCtx('userId')
  const t = useI18n()
  if (!services.length) return ''

  return (
    <div className={ className }>
      <div className='font-bold'>{ t('page:userId.services') }</div>
      <div className='py-5 space-y-3'>
        { services.map(({ name, priceText }) => (
          <div key={ name } className='flex items-center justify-between font-bold text-sm'>
            <div className='text-base'>{ t(`common:service.category.${name}`) }</div>
            <div>{ priceText }</div>
          </div>
        )) }
      </div>
    </div>
  )
}
